import {NgModule} from "@angular/core";
import {RouterModule, Routes} from "@angular/router";
import {PaymentsComponent} from './components/payments/phisical-account/payments.component';
import {PageNotFoundComponent} from "./components/page-not-found/page-not-found.component";
import {MainContainerComponent} from "./components/main-container/main-container.component";
import {LoginComponent} from "./components/login/login.component";
import {AuthGuard} from "./components/common/auth-guard";
import {PerfilComponent} from "./components/perfil/perfil.component";
import {PortalGuard} from "./components/common/portal-guard";
import {AccessGuard} from "./components/common/access-guard";
import {ConciliacionComponent} from "./components/conciliacion/conciliacion.component";
import {BusinessRulesComponent} from "./components/businessRules/businessRules.component";
import {DashboardComponent} from "./components/dashboard/dashboard.component";
import {RegistroUsuariosComponent} from "./components/usuariosppap/registro-usuarios.component";
import {EAccountComponent} from './components/payments/electronic-account/e-account.component';
import {WalletAccountComponent} from './components/transfers/wallet-account/wallet-account.component';
import {SalesChartComponent} from "./components/sales/sales-chart.component";
import {PromocionesComponent} from "./components/promociones/quantum/promociones.component";

import {AdminPromotionComponent} from "./components/promociones/quantum/admin-promotion/admin-promotion.component";
import {DetailPromotionComponent} from "./components/promociones/quantum/detail-promotion/detail-promotion.component";
import {ReferListComponent} from "./components/referrals/refer-list.component";

import {ReferComponent} from "./components/referrals/admin-refer/refer.component";
import {GanalottodoPromotionsComponent} from "./components/promociones/ganalottodo/ganalottodo-promotions.component";

/* Promociones ganalottodo */
import {GanalottodoPromotionComponent} from "./components/promociones/ganalottodo/admin-promotion/ganalottodo-promotion.component";
import {BannersComponent} from "./components/banners/banners.component";
import {AdminBannersComponent} from "./components/banners/admin-banners/admin-banners.component";
import {AdvanceUsersComponent} from "./components/advance-users/advance-users.component";
import {RisksModuleComponent} from "./components/risks-module/risks-module.component";
import {GanalottodoUsersComponent} from "./components/usuarios-ganalottodo/ganalottodo-users.component";
import {GanalottodoUserComponent} from "./components/usuarios-ganalottodo/ganalottodo-user/ganalottodo-user.component";
import {UploadAwardsComponent} from "./components/upload-awards/upload-awards.component";

export const routes: Routes = [
  {
    path: '',
    redirectTo: '/ganalottodo/dashboard',
    pathMatch: 'full'
  },
  {
    path: 'login',
    component: LoginComponent
  },
  {
    path: 'ganalottodo',
    component: MainContainerComponent,
    canActivate: [AuthGuard, PortalGuard, AccessGuard],
    children: [
      {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full'
      },
      {
        path: 'pagosCuentaElectronica',
        component: EAccountComponent
      },
      {
        path: 'abonoMonedero',
        component: WalletAccountComponent
      },
      {
        path: 'pagosCuentaClabe',
        component: PaymentsComponent
      },
      {
        path: 'dashboard',
        component: DashboardComponent
      },
      {
        path: 'profile',
        component: PerfilComponent
      },
      {
        path: 'conciliacion',
        component: ConciliacionComponent
      },
      {
        path: 'business-rules',
        component: BusinessRulesComponent
      },
      {
        path: 'risks-module',
        component: RisksModuleComponent
      },
      {
        path: 'usuarios',

        children: [
          {
            path: 'ganalottodo',
            component: GanalottodoUsersComponent
          },
          {
            path: 'ganalottodo/:username',
            component: GanalottodoUserComponent
          },
          {
            path: 'ppap',
            component: RegistroUsuariosComponent
          }
        ]
      },
      {
        path: 'sales',
        component: SalesChartComponent
      },
      {
        path: 'promotionsQuantum',
        component: PromocionesComponent
      },
      {
        path: 'promotionsGanalottodo/:promotionType',
        component: GanalottodoPromotionsComponent
      },
      {
        path: 'refers',
        component: ReferListComponent
      },
      {
        path: 'promotions/:promotionType/:promotionKey',
        component: DetailPromotionComponent
      },
      {
        path: 'adminPromotionComponent/:promocion',
        component: AdminPromotionComponent
      },
      {
        /* path: 'refer/:refer', */
        path: 'refer/:refer',
        component: ReferComponent
      },
      {
        path: 'ganalottodo-promotion/:promocion',
        component: GanalottodoPromotionComponent
      },
      {
        path: 'banners',
        component: BannersComponent
      },
      {
        path: 'banner/message/:message',
        component: AdminBannersComponent
      },

      {
        path: 'advance-users',
        component: AdvanceUsersComponent
      },{
        path: 'upload-awards',
        component: UploadAwardsComponent
      },

    ]
  },
  {path: '**', component: PageNotFoundComponent}
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {
}



// WEBPACK FOOTER //
// /codebuild/output/src14910448/src/src/app/app.routing.ts